import React from "react";
import Footer from "../global/Footer";
import CoverPage from "./CoverPage";
import Projects from "./Projects";
import { Box } from "@mui/material";
import Navbar from "../global/Navbar";

const index = () => {
  return (
    <Box
      sx={{
        width: {
          xs: "95%",
          md: "80%",
        },
        maxWidth: "1200px",
        margin: "0 auto",
        // minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        p: { xs: 2, md: 3 },
   
        gap: "30px",
        borderRadius: 2,
      }}
    >
      <Navbar />
      <CoverPage />
      <Projects />
      <Footer />
    </Box>
  );
};

export default index;
